import { IPrioritizationCriteriaSetting } from '../../interfaces/iprioritization-criteria-setting';
import { PrioritizationCriterion } from '../prioritization-criterion';

export class PrioritizationCriteriaSettingBase {
  PrioritizationCriteriaSettingId: number;
  PrioritizationCriterionId: number;
  ValueId: number | null;
  ValuePercent: number | null;
  ValueCurrency: number | null;
  ValueInteger: number | null;
  Preference: number;
  ValueDecimal: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  SortOrder: number;

  PrioritizationCriterion?: PrioritizationCriterion;

  constructor(item?: IPrioritizationCriteriaSetting) {
    if (item) {

      this.PrioritizationCriteriaSettingId = item.PrioritizationCriteriaSettingId;
      this.PrioritizationCriterionId = item.PrioritizationCriterionId;
      this.ValueId = item.ValueId;
      this.ValuePercent = item.ValuePercent;
      this.ValueCurrency = item.ValueCurrency;
      this.ValueInteger = item.ValueInteger;
      this.Preference = item.Preference;
      this.ValueDecimal = item.ValueDecimal;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.SortOrder = item.SortOrder;
      this.PrioritizationCriterion = new PrioritizationCriterion(item.PrioritizationCriterion);
    }
  }
}